import { render } from "./modal_photoarticle.vue?vue&type=template&id=6f15ca60&scoped=true"
import script from "./modal_photoarticle.vue?vue&type=script&lang=js"
export * from "./modal_photoarticle.vue?vue&type=script&lang=js"

import "./modal_photoarticle.vue?vue&type=style&index=0&id=6f15ca60&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f15ca60"]])

export default __exports__